import { useState, useEffect, createContext, Component } from 'react';
import ReactDOM from 'react-dom';
import serialize from 'form-serialize';
import axios from 'axios';
import { Route, Redirect } from 'react-router-dom';

import {api_path} from '../../../../server.js'; 

export default function Fertilizantes({analise, cultura, profundidade_cm}){

    const [classificacoes, setClassificacoes] = useState([]);
    const [classificao, setClassificao] = useState();
    const [classificaoLabel, setClassificaoLabel] = useState([]);

    const [caracteristicas_quimicas, setCaracteristicas_quimicas] = useState([]);
    const [caracteristica_quimica, setCaracteristica_quimica] = useState();

    const [tipos_fertilizantes, setTipos_fertilizantes] = useState([]);
    const [tipo_fertilizante, setTipo_fertilizante] = useState();
    
    const [isDisabled_tipo_fertilizante, setIsDisabled_tipo_fertilizante] = useState(false);
    
    const [fertilizantes_classificacao, setFertilizantes_classificacao] = useState([]);
    const [fertilizantes, setFertilizantes] = useState([]);

    const [classificacoes2, setClassificacoes2] = useState([]);
    const [classificao2, setClassificao2] = useState();
    const [classificaoLabel2, setClassificaoLabel2] = useState([]);

    const [caracteristicas_quimicas2, setCaracteristicas_quimicas2] = useState([]);
    const [caracteristica_quimica2, setCaracteristica_quimica2] = useState();
    
    const [tipos_fertilizantes2, setTipos_fertilizantes2] = useState([]);
    const [tipo_fertilizante2, setTipo_fertilizante2] = useState();
    
    const [isDisabled_tipo_fertilizante2, setIsDisabled_tipo_fertilizante2] = useState(false);
    
    const [fertilizantes_classificacao2, setFertilizantes_classificacao2] = useState([]);
    const [fertilizantes2, setFertilizantes2] = useState([]);

    const [isDisabled_gessagem, setIsDisabled_gessagem] = useState(false);
    const [isDisabled_calagem, setIsDisabled_calagem] = useState(false);

    const [textoAdubacao, setTextoAdubacao] = useState([]);

    const [FasesParaAdubacao, setFasesParaAdubacao] = useState([]);

    const [classificacao1_InputName, setClassificacao1_InputName] = useState();
    const [caracteristica_quimica1_InputName, setCaracteristica_quimica1_InputName] = useState();
    const [tipo_fertilizante1_InputName, setTipo_fertilizante1_InputName] = useState();
    const [fertilizante_InputName_complemento1, setFertilizante_InputName_complemento1] = useState();

    const [classificacao2_InputName, setClassificacao2_InputName] = useState();
    const [caracteristica_quimica2_InputName, setCaracteristica_quimica2_InputName] = useState();
    const [tipo_fertilizante2_InputName, setTipo_fertilizante2_InputName] = useState();
    const [fertilizante_InputName_complemento2, setFertilizante_InputName_complemento2] = useState();

    const [faseAdubacao1, setFaseAdubacao1] = useState('');
    const [faseAdubacao2, setFaseAdubacao2] = useState('');

    const [token, setToken] = useState();

    useEffect(()=>{
        let unmounted = false;
        if(!unmounted){
            getFasesParaAdubacao();
        }
        return () =>{
            unmounted=true;
          };
      }, [cultura])

    useEffect(()=>{
        let unmounted = false;
        if(!unmounted){

            const storageUser = localStorage.getItem("SistemaUser");
            if(storageUser){
                let storageSistemaUser = JSON.parse(storageUser);
                let user_token = storageSistemaUser.user_token;
                //console.log(storageSistemaUser);
                setToken(user_token);
                alert('Token '+user_token);
            }
            getClassificacao();  
            getClassificacao2();  
        }
        return () =>{
            unmounted=true;
        };

      }, [analise])
     
    useEffect(()=>{
        if(profundidade_cm==="00-20"){
                setIsDisabled_gessagem(true);
                setIsDisabled_calagem(false);
            }
        if(profundidade_cm==="20-40"){
                setIsDisabled_gessagem(false);
                setIsDisabled_calagem(true);
            }
      }, [profundidade_cm])
      
  async function getFasesParaAdubacao(){

      const bodyGetAnalise = {
        token: token,
        analise: analise
      }
      /*analise: analise*/
      
      axios.post(api_path()+'sistema/analisesolo/analise_solo_getFasesParaAdubacao.php', bodyGetAnalise, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then((response) => {
            var dadosgetFasesParaAdubacao= JSON.stringify(response.data);
            var dadosgetFasesParaAdubacaoArray = JSON.parse(dadosgetFasesParaAdubacao);
            setFasesParaAdubacao(dadosgetFasesParaAdubacaoArray);
            setClassificacao1_InputName(FasesParaAdubacao[0]+'_classificacao');
            setCaracteristica_quimica1_InputName(FasesParaAdubacao[0]+'_caracteristica_quimica');
            setTipo_fertilizante1_InputName(FasesParaAdubacao[0]+'_tipo_fertilizante');
            setFertilizante_InputName_complemento1(FasesParaAdubacao[0]);
            setFaseAdubacao1(FasesParaAdubacao[0]);
            if(FasesParaAdubacao[1]){
                setClassificacao2_InputName(FasesParaAdubacao[1]+'_classificacao');
                setCaracteristica_quimica2_InputName(FasesParaAdubacao[1]+'_caracteristica_quimica');
                setTipo_fertilizante2_InputName(FasesParaAdubacao[1]+'_tipo_fertilizante');
                setFertilizante_InputName_complemento2(FasesParaAdubacao[1]);
                setFaseAdubacao2(FasesParaAdubacao[1]);
            }
          })
          .catch(function (response) {
              //handle error
          });
          //return;
    }

  async function getClassificacao(){
      const bodyGetAnalise = {token:token, acao: 'getClassificacao'}
      axios.post(api_path()+'sistema/analisesolo/analise_solo_getClassificacao.php', bodyGetAnalise, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then((response) => {
            let dadosGetClassificacao= response.data;
            setClassificacoes(dadosGetClassificacao);
          })
          .catch(function (response) {
              //handle error
          });
          return;

    }
  async function getClassificacao2(){
        const bodyGetAnalise2 = {token: token, acao: 'getClassificacao'}
        axios.post(api_path()+'sistema/analisesolo/analise_solo_getClassificacao.php', bodyGetAnalise2, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
              let dadosGetClassificacao= response.data;
              setClassificacoes2(dadosGetClassificacao);
            })
            .catch(function (response) {
                //handle error
                //console.log(response)
            });
            return;
      }

    function handleClassificacao(e){
        setClassificao(e.target.value);
        let classifLabel = e.target.options[e.target.selectedIndex].text;
        let classifLabelLower = classifLabel.toLowerCase();
        setClassificaoLabel(classifLabelLower);
        setFertilizantes_classificacao(classifLabelLower);
    }
    function handleClassificacao2(e){
        setClassificao2(e.target.value);
        let classifLabel2 = e.target.options[e.target.selectedIndex].text;
        let classifLabel2Lower = classifLabel2.toLowerCase();
        setClassificaoLabel2(classifLabel2Lower);
        setFertilizantes_classificacao2(classifLabel2Lower);
    }

    function handleCaracteristicaQuimica(e){
        setTipo_fertilizante('');
        setCaracteristica_quimica(e.target.value);
    }
    function handleCaracteristicaQuimica2(e){
        setTipo_fertilizante2('');
        setCaracteristica_quimica2(e.target.value);
    }

    function handleTipoFertilizante(e){
        let tipoFertValue = e.target.value
        setTipo_fertilizante(tipoFertValue);
    }
    function handleTipoFertilizante2(e){
      let tipoFertValue2 = e.target.value
      setTipo_fertilizante2(tipoFertValue2);
    }

    useEffect(()=>{
        let unmounted = false;
        if(!unmounted){
            if(classificao!==""){ getCaracteristica_quimica(); }
        }
        return () =>{
            unmounted=true;
          };
      }, [classificao])

    useEffect(()=>{
        let unmounted = false;
        if(!unmounted){
            if(classificao2!==""){ getCaracteristica_quimica2(); }
        }
        return () =>{
            unmounted=true;
          };
      }, [classificao2])

    async function getCaracteristica_quimica(){
        const bodyGetCaracteristica_quimica = {token: token, acao: 'getCaracteristica_quimica', classificacao: classificao}
            axios.post(api_path()+'sistema/analisesolo/analise_solo_getCaracteristica_quimica.php', bodyGetCaracteristica_quimica, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
            .then((response) => {
                    let dadosGetCaracteristica_quimica = response.data;
                    setCaracteristicas_quimicas(dadosGetCaracteristica_quimica);
                })
                .catch(function (response) {
                    //console.log(response)
                });
                return;
      }
    async function getCaracteristica_quimica2(){
        const bodyGetCaracteristica_quimica2 = {token: token, acao: 'getCaracteristica_quimica', classificacao: classificao2}
            axios.post(api_path()+'sistema/analisesolo/analise_solo_getCaracteristica_quimica.php', bodyGetCaracteristica_quimica2, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
            .then((response) => {
                    let dadosGetCaracteristica_quimica2 = response.data;
                    setCaracteristicas_quimicas2(dadosGetCaracteristica_quimica2);
                })
                .catch(function (response) {
                    //console.log(response)
                });
                return;
        }

    useEffect(()=>{
        let unmounted = false;
        if(!unmounted){
            getTipo_fertilizante();
            getFertilizante();
        }
        return () =>{
            unmounted=true;
        };
        //setCaracteristica_quimica
        
    }, [caracteristica_quimica])

    useEffect(()=>{
        let unmounted = false;
        if(!unmounted){
            getTipo_fertilizante2();
            getFertilizante2();
        }
        return () =>{
            unmounted=true;
        };
    }, [caracteristica_quimica2])


      async function getTipo_fertilizante(){
        const bodyGetTipo_fertilizante = {token: token, acao: 'getTipo_fertilizante', classificacao: classificao, caracteristica_quimica: caracteristica_quimica}
            axios.post(api_path()+'sistema/analisesolo/analise_solo_getTipo_fertilizante.php', bodyGetTipo_fertilizante, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
            .then((response) => {
                    let dadosGetTipo_fertilizante = response.data;
                    setTipos_fertilizantes(dadosGetTipo_fertilizante);
                })
                .catch(function (response) {
                    //console.log(response)
                });
                return;            
      }
      async function getTipo_fertilizante2(){
        const bodyGetTipo_fertilizante2 = {token: token, acao: 'getTipo_fertilizante', classificacao: classificao2, caracteristica_quimica: caracteristica_quimica2}
            axios.post(api_path()+'sistema/analisesolo/analise_solo_getTipo_fertilizante.php', bodyGetTipo_fertilizante2, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
            .then((response) => {
                    let dadosGetTipo_fertilizante = response.data;
                    setTipos_fertilizantes2(dadosGetTipo_fertilizante);
                })
                .catch(function (response) {
                    //console.log(response)
                });
                return;
      }

    useEffect(()=>{
        let unmounted = false;
        if(!unmounted){
            if(classificaoLabel==="formulado"){
                setIsDisabled_tipo_fertilizante(false);
            }
            if(classificaoLabel==="simples"){
                setIsDisabled_tipo_fertilizante(true);
            }
            getFertilizante();
        }
        return () =>{
            unmounted=true;
        };
    }, [classificao, tipo_fertilizante, classificaoLabel])

    useEffect(()=>{
        let unmounted = false;
        if(!unmounted){
            if(classificaoLabel2==="formulado"){
                setIsDisabled_tipo_fertilizante2(false);
            }
            if(classificaoLabel2==="simples"){
                setIsDisabled_tipo_fertilizante2(true);
            }
            getFertilizante2();
        }
        return () =>{
            unmounted=true;
        };
    }, [classificao2, tipo_fertilizante2, classificaoLabel2])

      async function getFertilizante(){
        getFasesParaAdubacao();
        setFertilizantes([]);
        const bodyGetTipo_fertilizante = {
          token: token,
          acao: 'getFertilizante',
          desc:'testesimples',
          classificacao: classificao,
          caracteristica_quimica: caracteristica_quimica,
          tipo_fertilizante: tipo_fertilizante,
          cultura: cultura,
          fase: faseAdubacao1
        }

            axios.post(api_path()+'sistema/analisesolo/analise_solo_getFertilizante.php', bodyGetTipo_fertilizante, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
            .then((response) => {
                    let dadosGetFertilizante = response.data.fertilizante;
                    let dadosGetFertilizanteClassificacao = response.data.classificacao;
                    let dadosGetFertilizanteClassificacaoLower = dadosGetFertilizanteClassificacao.toLowerCase();
                    let nrfields = dadosGetFertilizante.length;
                    setFertilizantes(dadosGetFertilizante);
                    setFertilizantes_classificacao(dadosGetFertilizanteClassificacaoLower);
                })
                .catch(function (response) {
                    //console.log(response)
                });
                return;



      }
    async function getFertilizante2(){
        setFertilizantes2([]);
        const bodyGetTipo_fertilizante2 = {
          token: token,
          acao: 'getFertilizante',
          classificacao: classificao2,
          caracteristica_quimica: caracteristica_quimica2,
          tipo_fertilizante: tipo_fertilizante2,
          cultura: cultura,
          fase: faseAdubacao2
        }

            axios.post(api_path()+'sistema/analisesolo/analise_solo_getFertilizante.php', bodyGetTipo_fertilizante2, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
            .then((response) => {
                    let dadosGetFertilizante2 = response.data.fertilizante;
                    let dadosGetFertilizanteClassificacao2 = response.data.classificacao;
                    let dadosGetFertilizanteClassificacao2Lower = dadosGetFertilizanteClassificacao2.toLowerCase();
                    let nrfields = dadosGetFertilizante2.length;
                    setFertilizantes2(dadosGetFertilizante2);
                    setFertilizantes_classificacao2(dadosGetFertilizanteClassificacao2Lower);
                })
                .catch(function (response) {
                    //console.log(response)
                });
                return;
      }

    const [btGerar_text, set_btGerar_text] = useState('Gerar Recomendações');


    function handleSubmitFertilizante(e){
        e.preventDefault();

        var resultado = window.confirm("Deseja realmente finalizar?");
        if (resultado === true) {

            alert("Análise finalizada! Você será direcionado ao Laudo.");    
            set_btGerar_text('Aguarde, Gerando...');
            const form = e.currentTarget;
            let dados= serialize(form, {hash: true, empty: true});
            const bodyFert = {token: token, acao: 'setFertilizante', analise: analise, type: fertilizantes_classificacao, dados}

            if(analise){
            
                axios.post(api_path()+'sistema/analisesolo/analise_solo_setFertilizante.php', bodyFert, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                .then((response) => {
                        let dadosAdubacao = response.data;
                        let retornoAnalideId = dadosAdubacao.analise;
                        //console.log(dadosAdubacao);
                        if(retornoAnalideId){
                            const storageUser = localStorage.getItem("SistemaUser");
                            if(storageUser){
                                let storageSistemaUser = JSON.parse(storageUser);
                                let dadosLocalStorage = {
                                    user_id: storageSistemaUser.user_id,
                                    user_email: storageSistemaUser.user_email,
                                    user_nome: storageSistemaUser.user_nome,
                                    user_token: storageSistemaUser.user_token,
                                    solo_id: null
                                  };
                                localStorage.setItem('SistemaUser', JSON.stringify(dadosLocalStorage));
                            } 
                            let storaGeUserAtualizado = localStorage.getItem("SistemaUser");
                            let storaGeUserAtualizado_parse = JSON.parse(storageUser);
                            let solo_id_null = storaGeUserAtualizado_parse.solo_id;
                            //console.log('!!! '+retornoAnalideId);
                            //alert(retornoAnalideId);
                            document.location.href = '../analise-solo/laudo?id='+retornoAnalideId;
                        }else{
                            alert('Não foi possível finalizar.');
                            set_btGerar_text('Gerar Recomendações');
                        }
                    })
                    .catch(function (response) {
                        //console.log(response);
                    });
                    return;
            }else{
                alert('Id da análise nulo!');
            }


        
        }
        else{
            //alert("Você desistiu de excluir o item da lista!");
        }


    }

    
    return(
        <div>
        <form method="POST" name="formFertilizante" id="formFertilizante" onSubmit={handleSubmitFertilizante}>
        
        <div class="grid-x">
            <div className="small-12 medium-12 large-12 cell">
          
                <div class="card">
                    <div class="card-divider"><h4>Fertilizante ({FasesParaAdubacao[0]})</h4></div>
                    <div class="card-section">

                        <div className="grid-x grid-padding-x categoriasfertilizantes_combos">
                            <div className="small-12 medium-4 large-4 cell">
                                <label htmlFor={classificacao1_InputName} className="form-label">Classificação</label>
                                <select className="form-select" name={classificacao1_InputName} id={classificacao1_InputName} value={classificao} onChange={(e)=>handleClassificacao(e)} required>
                                <option value="">Selecione...</option>
                                {classificacoes.map((item, index) => {
                                return(
                                    <option key={item.codigo} value={item.codigo} >
                                    {item.classificacao}
                                    </option>
                                )
                                })}
                                </select>
                            </div>
                            <div className="small-12 medium-4 large-4 cell">
                                <label htmlFor={caracteristica_quimica1_InputName} className="form-label">Característica Química</label>
                                <select className="form-select caracteristica_quimica" name={caracteristica_quimica1_InputName} id={caracteristica_quimica1_InputName} onChange={(e)=>handleCaracteristicaQuimica(e)} required>
                                <option value="">Selecione...</option>
                                {classificao!=="" &&
                                caracteristicas_quimicas.map((item, index) => {
                                return(
                                    <option key={item.codigo} value={item.codigo} >
                                    {item.caracteristica_quimica}
                                    </option>
                                )
                                })}
                                
                                </select>
                            </div>
                            <div className="small-12 medium-4 large-4 cell">
                                <label htmlFor={tipo_fertilizante1_InputName} className="form-label">Tipo do Fertilizante</label>
                                <select className="form-select tipo_fertilizante" name={tipo_fertilizante1_InputName} id={tipo_fertilizante1_InputName} onChange={(e)=>handleTipoFertilizante(e)} disabled={isDisabled_tipo_fertilizante} required>
                                <option value="">Selecione...</option>
                                {caracteristica_quimica!=="" &&
                                tipos_fertilizantes.map((item, index) => {
                                return(
                                    <option key={item.codigo} value={item.codigo} >
                                    {item.tipo_fertilizante}
                                    </option>
                                )
                                })}
                                </select>
                            </div>
                        </div>
                    
            
                        <div className="grid-x grid-padding-x lista-fertilizantes">
                        {fertilizantes_classificacao==="simples" &&

                                fertilizantes.map((item, index) => {
                                    //console.log(fertilizantes_classificacao)

                                        if(item.tipo && item.tipo!==""){
                                            return(
                                                <div className="small-12 medium-12 large-12 cell" key={item.tipo}>
                                                    <p className='nomeFertilizante'>{item.tipo}</p>
                                                </div>
                                            )
                                        }
                                        if(!item.tipo && item.descricao!==""){
                                            let tipo_fertilizante_componente = classificaoLabel+"_"+fertilizante_InputName_complemento1+"_fertilizante_"+item.tipo_id;
                                            let idRadio = classificaoLabel+"_"+fertilizante_InputName_complemento1+"_radio"+item.codigo;
                                            return(
                                                <div className="small-12 medium-3 large-3 cell" key={item.descricao}>
                                                    <label htmlFor={idRadio}><input type="radio" name={tipo_fertilizante_componente} value={item.codigo} id={idRadio} required/>{item.descricao}</label>
                                                </div>
                                            )
                                        }
                                })

                        
                        }

                        {
                            fertilizantes_classificacao==="formulado" &&
                            fertilizantes.map((item, index) => {
                                //console.log(fertilizantes_classificacao);
                                //if(item.tipo && item.tipo!="" && fertilizantes_classificacao=="simples"){
                                if(item.tipo && item.tipo!=="" && fertilizantes_classificacao!="simples"){
                                    return(
                                        <div className="small-12 medium-12 large-12 cell" key={item.tipo}>
                                            <p className='nomeFertilizante'>{item.tipo}</p>
                                        </div>
                                    )
                                }
                                if(!item.tipo && item.descricao!==""){
                                    let tipo_fertilizante_componente = classificaoLabel+"_"+fertilizante_InputName_complemento1+"_fertilizante_"+item.tipo_id;
                                    let idRadio = classificaoLabel+"_"+fertilizante_InputName_complemento1+"_radio"+item.codigo;
                                    //console.log(idRadio);
                                    return(
                                        <div className="small-12 medium-3 large-3 cell" key={item.descricao}>
                                            <label className="form-check-label" htmlFor={idRadio}><input className="form-check-input" type="radio" name={tipo_fertilizante_componente} value={item.codigo} id={idRadio} required/>{item.descricao}</label>
                                        </div>
                                    )
                                }
                            })
                        }
                        </div>

                    </div>
                </div>

                {/*
                FasesParaAdubacao.length===2 &&       
                <div className="tituloModulo">Fertilizante ({FasesParaAdubacao[1]})</div>
                    */}
                {
                FasesParaAdubacao.length===2 &&
                <div>
                <div class="card">
                    <div class="card-divider"><h4>Fertilizante ({FasesParaAdubacao[1]})</h4></div>
                    <div class="card-section">

                    <div className="grid-x grid-padding-x categoriasfertilizantes_combos">
                        <div className="small-12 medium-4 large-4 cell">
                            <label htmlFor={classificacao2_InputName} className="form-label">Classificação</label>
                            <select name={classificacao2_InputName} id={classificacao2_InputName} value={classificao2} onChange={(e)=>handleClassificacao2(e)} required>
                            <option value="">Selecione...</option>
                            {classificacoes2.map((item, index) => {
                            return(
                                <option key={item.codigo} value={item.codigo} >
                                {item.classificacao}
                                </option>
                            )
                            })}
                            </select>
                        </div>
                        <div className="small-12 medium-4 large-4 cell">
                            <label htmlFor={caracteristica_quimica2_InputName} className="form-label">Característica Química</label>
                            <select className="caracteristica_quimica" name={caracteristica_quimica2_InputName} id={caracteristica_quimica2_InputName} onChange={(e)=>handleCaracteristicaQuimica2(e)} required>
                            <option value="">Selecione...</option>
                            {classificao2!=="" &&
                            caracteristicas_quimicas2.map((item, index) => {
                            return(
                                <option key={item.codigo} value={item.codigo} >
                                {item.caracteristica_quimica}
                                </option>
                            )
                            })}
                            
                            </select>
                        </div>
                        <div className="small-12 medium-4 large-4 cell">
                            <label htmlFor={tipo_fertilizante2_InputName} className="form-label">Tipo do Fertilizante</label>
                            <select className="tipo_fertilizante" name={tipo_fertilizante2_InputName} id={tipo_fertilizante2_InputName} onChange={(e)=>handleTipoFertilizante2(e)} disabled={isDisabled_tipo_fertilizante2} required>
                            <option value="">Selecione...</option>
                            {caracteristica_quimica2!=="" &&
                            tipos_fertilizantes2.map((item, index) => {
                            return(
                                <option key={item.codigo} value={item.codigo} >
                                {item.tipo_fertilizante}
                                </option>
                            )
                            })}
                            </select>
                        </div>
                    </div>

                    <div className="grid-x grid-padding-x lista-fertilizantes">
                    { fertilizantes_classificacao2==="simples" &&
                        fertilizantes2.map((item, index) => {
                            //console.log('simples');
                            if(item.tipo && item.tipo!=="" && fertilizantes_classificacao2==="simples"){
                                return(
                                    <div className="small-12 medium-12 large-12 cell" key={item.tipo}>
                                        <p className='nomeFertilizante'>{item.tipo}</p>
                                    </div>
                                )
                            }
                            if(!item.tipo && item.descricao!==""){
                                let tipo_fertilizante_componente2 = classificaoLabel2+"_"+fertilizante_InputName_complemento2+"_fertilizante_"+item.tipo_id;
                                let idRadio2 = classificaoLabel2+"_"+fertilizante_InputName_complemento2+"_radio"+item.codigo;
                                return(
                                    <div className="small-12 medium-3 large-3 cell" key={item.descricao}>
                                        <label htmlFor={idRadio2}><input type="radio" name={tipo_fertilizante_componente2} value={item.codigo} id={idRadio2} required/>{item.descricao}</label>
                                    </div>
                                )
                            }
                        })
                    }

                    {
                        fertilizantes_classificacao2==="formulado" &&
                        fertilizantes2.map((item2, index) => {
                            if(item2.tipo && item2.tipo!=="" && fertilizantes_classificacao2==="simples"){
                                return(
                                    <div className="small-12 medium-12 large-12 cell" key={item2.tipo}>
                                        <p className='nomeFertilizante2'>{item2.tipo}</p>
                                    </div>
                                )
                            }
                            if(!item2.tipo && item2.descricao!==""){
                                let tipo_fertilizante_componente2 = classificaoLabel2+"_"+fertilizante_InputName_complemento2+"_fertilizante_"+item2.tipo_id;
                                let idRadio2 = classificaoLabel2+"_"+fertilizante_InputName_complemento2+"_radio"+item2.codigo;
                                //console.log('formulado');
                                return(
                                    <div className="small-12 medium-3 large-3 cell" key={item2.descricao}>
                                        <label htmlFor={idRadio2}><input type="radio" name={tipo_fertilizante_componente2} value={item2.codigo} id={idRadio2} required/>{item2.descricao}</label>
                                    </div>
                                )
                            }
                        })
                    }
                    </div>

                    </div>


                    </div>
                </div>

                }

                <div class="card">
                    <div class="card-divider"><h4>Calagem e Gessagem</h4></div>
                    <div class="card-section">

                        <div className="grid-x grid-padding-x">
                            <div className="small-12 medium-3 large-3 cell">
                                <label htmlFor="nome_razao" className="form-label">Recomendação de Calagem</label>
                                <select className="form-select" name="calagem" id="calagem" disabled={isDisabled_calagem} required>
                                <option value=""></option>
                                <option value="BR">Método Brasileiro</option>
                                <option value="EUA">Método Americano</option>
                                </select>
                            </div>
                            <div className="small-12 medium-3 large-3 cell">
                                <label htmlFor="nome_razao" className="form-label">Recomendação de Gessagem</label>
                                <select className="form-select" name="gessagem" id="gessagem" disabled={isDisabled_gessagem} required>
                                <option value=""></option>
                                <option value="EMBRAPA">Método Embrapa/SOUSA et al</option>
                                </select>
                            </div>
                            <div className="small-12 medium-6 large-6 cell align-right">
                                <button type="submit" id="gerar_recomendacoes" className="submit success button large float-right">{btGerar_text}</button>
                            </div>
                        </div>
                        
                    </div>
                </div>


          </div>
        </div> 



        </form>


        </div>
    );


}